import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import illustration from "@/assets/topshop/topshop-illustration.webp";
import { TopShopStatusBadge, useMyTopShopApplication } from "./topShopShared";

export function TopShopStatusCard() {
  const { data, isLoading, error } = useMyTopShopApplication();
  if (isLoading || error || !data) return null;
  const hasPhotos = data.photos.length > 0;

  return (
    <Card>
      <CardContent className="flex flex-col sm:flex-row sm:items-center gap-4 p-4">
        <img src={illustration} alt="" className="h-16 w-16 object-contain shrink-0" />
        <div className="flex-1 space-y-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h2 className="font-semibold text-lg">Top Shop Challenge</h2>
            <TopShopStatusBadge status={data.application.status} />
          </div>
          {!hasPhotos && (
            <p className="text-sm text-muted-foreground">Add photos of your shop to complete your application.</p>
          )}
        </div>
        <Button asChild>
          <Link to="/topshop/application">{hasPhotos ? "View your application" : "Add photos"}</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
